import { useEffect, useState } from 'react';

import { useLocalStorage } from '@spotify/confidence-core-react';

import { useCurrentUser } from '../useCurrentUser';

export const useDefaultOwner = (initialValue?: string) => {
  const [defaultOwner, setDefaultOwner] = useLocalStorage<string | null>(
    'default-owner-v2',
    null,
  );
  const [owner, setOwner] = useState<string | null>(
    initialValue ?? defaultOwner,
  );

  const [isInitialized, setIsInitialized] = useState(false);

  const { currentUser, isLoading: loading } = useCurrentUser({
    skip: owner !== null || isInitialized,
  });

  useEffect(() => {
    // Only auto-set owner to currentUser if we haven't initialized yet and no owner is set
    if (currentUser && owner === null && !isInitialized) {
      const currentUserName = currentUser.identity.name;
      setDefaultOwner(currentUserName);
      setOwner(currentUserName);
      setIsInitialized(true);
    } else if (!isInitialized) {
      // Mark as initialized even if we don't have a currentUser
      setIsInitialized(true);
    }
  }, [currentUser, owner, isInitialized, setDefaultOwner]);

  useEffect(() => {
    if (owner && !initialValue) {
      setDefaultOwner(owner);
    }
  }, [owner, setDefaultOwner, initialValue]);

  return [owner, setOwner, { loading }] as const;
};
